/**
 * @file pdfAnnotator.actions.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jul 14, 2026 20:19
 */
export const PDF_ANNOTATOR_SEARCH_DRAWER_TOGGLE = 'PDF_ANNOTATOR_SEARCH_DRAWER_TOGGLE';
export function pdfAnnotatorSearchDrawerToggle() {
    return {
        type: PDF_ANNOTATOR_SEARCH_DRAWER_TOGGLE,
    };
}
